import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  '558f528fd0ba9b2677bbbb2f6745493dTz0xMzIyMzIsRT0xODE4OTc5MTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
)

export default LicenseInfo
